import { defineComponent as n, createBlock as a, openBlock as r, unref as l, mergeProps as m, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconBike",
  __name: "IconBike",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (r(), a(l(c), m(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M13 4.75a.75.75 0 0 0 0 1.5h2.424l.82 3H8.711L7.917 7.664a.75.75 0 0 0-.67-.414H5a.75.75 0 0 0 0 1.5h1.783l1.12 2.237a4.25 4.25 0 1 0 2.652 5.29 1 1 0 0 0 .85.473h2.22a4.25 4.25 0 1 0 4.578-5.942l.02-.006-1.503-5.5a.75.75 0 0 0-.724-.552H13m-3.539 6 2.252 4.5h1.544a4.251 4.251 0 0 1 3.419-4.42l-.022-.08H9.461m-2.961 7a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5m11 0a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
